module.exports = __webpack_public_path__ + "static/img/A148.b614959f.jpg";